import { ErrorLogComponent } from '@cian/error-log-component';
import { Spinner } from '@cian/ui-kit';

import { type FC } from 'react';

import { MapContext } from '@/microfrontends/map/shared/context/MapContext';
import { useMapAppContext } from '@/microfrontends/map/shared/context/mapAppContext';

import { useGetYandexMapScriptQuery } from '@/packages/query-state/shared/store/yandex-map/2.1/get-yandex-map/query';

import { MapControlsSlotsContainer } from '../MapControlsSlots';
import { MapLayersCenter } from '../MapLayersCenter';
import { MapManagers } from '../MapManagers';
import { MapNotificationsContainer } from '../MapNotifications';

import { MapError } from './internal/components/MapError';

export const MapContainer: FC = () => {
  const { isFetching, isError, isSuccess, refetch } = useGetYandexMapScriptQuery();

  const { logger } = useMapAppContext();
  const onRetry = (): void => {
    refetch();
  };

  if (isError) {
    return <MapError onRetry={onRetry} />;
  }

  if (!isSuccess && isFetching) {
    return <Spinner size={50} />;
  }

  return (
    <ErrorLogComponent errorStub={<MapError />} level="error" logger={logger}>
      <MapContext>
        <MapNotificationsContainer />
        <MapControlsSlotsContainer />
        <MapManagers />
        <MapLayersCenter />
      </MapContext>
    </ErrorLogComponent>
  );
};
